var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1354,
    viewBox: "0 0 1920 1354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 907.824,
    cy: 338.405,
    rx: 803.34,
    ry: 1053.62,
    transform: "rotate(-90.0614 907.824 338.405)",
    fill: "url(#paint0_linear_39_160)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 171.5,
    cy: 985.5,
    r: 330.5,
    fill: "url(#paint1_linear_39_160)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1888.5,
    cy: 609.5,
    r: 330.5,
    fill: "url(#paint2_linear_39_160)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 1816.5,
    cy: 1023.5,
    r: 330.5,
    fill: "url(#paint3_linear_39_160)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_160",
    x1: 390.865,
    y1: 329.438,
    x2: 1100.25,
    y2: 301.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BA397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA397",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_160",
    x1: 171.5,
    y1: 655,
    x2: 171,
    y2: 1083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_160",
    x1: 1888.5,
    y1: 279,
    x2: 1888,
    y2: 707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA397"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_160",
    x1: 1816.5,
    y1: 693,
    x2: 1816,
    y2: 1121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BA397"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackg);
export default __webpack_public_path__ + "static/media/backg.8cecd88f627771b159f5078fc077ae00.svg";
export { ForwardRef as ReactComponent };